import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const getAllYears = createAsyncThunk('/year/getAllYears',
    async () => {
        try {
            const myurl = `${V_URL}/believe/get-year-dropdown`;

            const response = await axios({
                method: 'get',
                url: myurl,
            });

            const data = response.data;

            if (data.success === true) {
                return data;
            } else {
                throw new Error(data);
            }
        } catch (error) {
            console.log(error, "error");
            toast.error(error.response.data.message);
            return error
        }
    })

const getAllYearSlice = createSlice({
    name: "getAllYears",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllYears.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllYears.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getAllYears.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default getAllYearSlice.reducer;